export default function BrandIntro() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="w-full lg:w-2/5">
            <div className="rounded-2xl overflow-hidden aspect-square">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cute%20artistic%20illustration%20of%20a%20fluffy%20white%20rabbit%20mascot%20in%20a%20cozy%20pastel%20world%20with%20floating%20hearts%20and%20stars%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20kawaii%20brand%20logo%20style%2C%20clean%20minimal%20design&width=600&height=600&seq=about-brand-01&orientation=squarish"
                alt="嫩小兔品牌形象"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="w-full lg:w-3/5">
            <p className="text-xs md:text-sm font-label text-primary-500 tracking-widest mb-2">
              ✦ ABOUT US ✦
            </p>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-4">
              关于嫩小兔
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              <strong>嫩小兔</strong>诞生于2019年，是深受年轻人喜爱的<strong>萌系潮流品牌</strong>。品牌以"软萌治愈"为核心理念，通过<strong>嫩小兔玩偶</strong>、<strong>嫩小兔周边</strong>、联名产品和限定礼盒，为年轻消费者带来温暖、可爱且有品质的生活方式体验。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              我们的使命是用萌趣的产品传递治愈力量。在这个快节奏的时代，每个人都需要一只软萌的兔子来缓冲生活的压力。嫩小兔不仅是一个玩具品牌，更是一种生活态度——用柔软的方式面对世界。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              截至目前，嫩小兔在社交媒体上拥有超过<strong>500万</strong>粉丝，产品线覆盖毛绒玩具、生活周边、联名合作三大领域。我们的产品远销海内外，受到全球萌兔爱好者的喜爱。
            </p>

            <div className="grid grid-cols-3 gap-4 mt-8">
              <div className="text-center p-4 rounded-2xl bg-primary-50/70">
                <p className="font-label text-2xl md:text-3xl font-bold text-primary-500">500万+</p>
                <p className="text-xs text-foreground-600 mt-1">社交媒体粉丝</p>
              </div>
              <div className="text-center p-4 rounded-2xl bg-accent-50/70">
                <p className="font-label text-2xl md:text-3xl font-bold text-accent-500">100+</p>
                <p className="text-xs text-foreground-600 mt-1">产品品类</p>
              </div>
              <div className="text-center p-4 rounded-2xl bg-secondary-100/70">
                <p className="font-label text-2xl md:text-3xl font-bold text-secondary-600">30+</p>
                <p className="text-xs text-foreground-600 mt-1">覆盖城市</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}